export default "__VITE_ASSET__CELfveCg__"